import { render } from "./ShipmentList.vue?vue&type=template&id=7340228e&scoped=true"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"

import "./ShipmentList.vue?vue&type=style&index=0&id=7340228e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7340228e"]])

export default __exports__